import { render, staticRenderFns } from "./GlobalSettingDetails.vue?vue&type=template&id=a65915de"
import script from "./GlobalSettingDetails.vue?vue&type=script&lang=js"
export * from "./GlobalSettingDetails.vue?vue&type=script&lang=js"
import style0 from "./GlobalSettingDetails.vue?vue&type=style&index=0&id=a65915de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports